import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { RouteConstants } from '../../../../../core/constants/routes';
import { UserStateService } from '../../../../user/shared/services/user-state/user-state.service';
import { AppStorageService } from '../../../../../core/services/app-storage/app-storage.service';
import { ApplicationPreparationQuestionnaireService } from '../../services/application-preparation-questionnaire/application-preparation-questionnaire.service';
import { AccessConstants } from '../../../../../core/constants/access-constants';

/**
 * Application routes that cannot be directly navigated to outside of the application flow.
 */
const RESTRICTED_URLS = [
    RouteConstants.Application.getFullRoute('quickStart'),
    // Other routes that are restricted
];

export const ApplicationEntryInitializerResolver = (
    // Even though `route` isn't directly referenced, it is necessary for the full URL to be captured
    // by state.url. Do not remove this.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
    const router = inject(Router);
    const userStateService = inject(UserStateService);
    const appStorageService = inject(AppStorageService);
    const applicationPreparationQuestionnaireService = inject(
        ApplicationPreparationQuestionnaireService,
    );

    const role = userStateService.getRole();

    if (
        !role ||
        !AccessConstants.RolesThatCanCreateApplicationsForOtherCustomers.includes(
            role,
        )
    ) {
        // Make sure that any previously stored state is removed when the current role does not have permission
        // to create applications on behalf of other CiviCRM Contacts.
        appStorageService.clearContactCiviId();
        applicationPreparationQuestionnaireService.clearCiviId();
    }

    const url = state.url;

    if (RESTRICTED_URLS.includes(url)) {
        console.log(`'Unable to navigate to the form options page directly.`);

        router.navigate(['/']);
        return;
    }
};
